import { render, staticRenderFns } from "./ServiceSpecial.vue?vue&type=template&id=66498e66&scoped=true"
import script from "./ServiceSpecial.vue?vue&type=script&lang=js"
export * from "./ServiceSpecial.vue?vue&type=script&lang=js"
import style0 from "./ServiceSpecial.vue?vue&type=style&index=0&id=66498e66&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66498e66",
  null
  
)

export default component.exports